import { Injectable, Injector, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import axios from "axios";
import { AxiosInstance } from "axios";
import { Subject } from "rxjs";
import { EStorageType } from "../data-types/storage.enum";
import { LocalStorageService } from "./local-storage.service";

export enum versionEnum {
  V1 = 'v1',
  V2 = 'v2',
}

@Injectable({
  providedIn: "root",
})
export class HttpClientService implements OnInit {
  static instance: HttpClientService = new HttpClientService();
  unauthorizedSubject = new Subject();
  private axiosClient: AxiosInstance;
  private translate: TranslateService;
  private devUrl: string = "http://15.236.209.208:8080/api/";
  private prodUrl: string = "https://api.cowing.es/api/";
  private apiUrl: string = "";

  constructor() {
    this.axiosClient = axios.create({
      headers: {
        "X-Initialized-At": Date.now().toString(),
        "Access-Control-Allow-Origin": "*",
      },
    });

    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  }

  ngOnInit() {}
  public async post<T>(url, headers, body, version = versionEnum.V1): Promise<T> {
    const lang = LocalStorageService.instance.get(EStorageType.Language) || this.translate.defaultLang;
    this.axiosClient.defaults.headers["Accept-Language"] = lang;
    try {
      // undefined,
      var axiosResponse = await this.axiosClient.request<T>({
        method: "post",
        url: `${this.apiUrl}${version}/${url}`,
        headers,
        data: body,
      });
      return axiosResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        const token = LocalStorageService.instance.get(EStorageType.Token)
        if (token) {
          await this.callRefreshToken()
          this.axiosClient.defaults.headers["Authorization"] = `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          headers = {
            Authorization : `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          }
          var axiosResponse = await this.axiosClient.request<T>({
            method: "post",
            url: `${this.apiUrl}${version}/${url}`,
            headers,
            data: body,
          });
          return axiosResponse.data;
        }
      }
        return Promise.reject(error.response);
    }
  }

  public getUnauthorizedSubject() {
    return this.unauthorizedSubject.asObservable();
  }

  public async get<T>(url, headers?, version = versionEnum.V1): Promise<T> {
    const lang = LocalStorageService.instance.get(EStorageType.Language);
    this.axiosClient.defaults.headers["Accept-Language"] = lang;
    try {
      var axiosResponse = await this.axiosClient.request<T>({
        method: "get",
        url: `${this.apiUrl}${version}/${url}`,
        headers,
      });
      return axiosResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        const token = LocalStorageService.instance.get(EStorageType.Token)
        if (token) {
          await this.callRefreshToken()
          this.axiosClient.defaults.headers["Authorization"] = `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          headers = {
            Authorization : `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          }
          var axiosResponse = await this.axiosClient.request<T>({
            method: "get",
            url: `${this.apiUrl}${version}/${url}`,
            headers,
          });
          return axiosResponse.data;
        }
      }
      return Promise.reject(error.response);
    }
  }

  public async delete<T>(url, headers?, version = versionEnum.V1): Promise<T> {
    const lang = LocalStorageService.instance.get(EStorageType.Language);
    this.axiosClient.defaults.headers["Accept-Language"] = lang;
    try {
      var axiosResponse = await this.axiosClient.request<T>({
        method: "delete",
        url: `${this.apiUrl}${version}/${url}`,
        headers,
      });
      return axiosResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        const token = LocalStorageService.instance.get(EStorageType.Token)
        if (token) {
          await this.callRefreshToken()
          this.axiosClient.defaults.headers["Authorization"] = `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          headers = {
            Authorization : `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          }
          var axiosResponse = await this.axiosClient.request<T>({
            method: "delete",
            url: `${this.apiUrl}${version}/${url}`,
            headers,
          });
          return axiosResponse.data;
        }
      }
      return Promise.reject(error.response.data);
    }
  }

  public async put<T>(url, headers, body, version = versionEnum.V1): Promise<T> {
    const lang = LocalStorageService.instance.get(EStorageType.Language);
    this.axiosClient.defaults.headers["Accept-Language"] = lang;
    try {
      var axiosResponse = await this.axiosClient.request<T>({
        method: "put",
        url: `${this.apiUrl}${version}/${url}`,
        headers,
        data: body,
      });

      return axiosResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        const token = LocalStorageService.instance.get(EStorageType.Token)
        if (token) {
          await this.callRefreshToken()
          this.axiosClient.defaults.headers["Authorization"] = `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          headers = {
            Authorization : `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          }
          var axiosResponse = await this.axiosClient.request<T>({
            method: "put",
            url: `${this.apiUrl}${version}/${url}`,
            headers,
            data: body,
          });
          return axiosResponse.data;
        }
      }
      return Promise.reject(error.response);
    }
  }

  public async patch<T>(url, headers, body?, version = versionEnum.V1): Promise<T> {
    const lang = LocalStorageService.instance.get(EStorageType.Language);
    this.axiosClient.defaults.headers["Accept-Language"] = lang;
    try {
      var axiosResponse = await this.axiosClient.request<T>({
        method: "patch",
        url: `${this.apiUrl}${version}/${url}`,
        headers,
        data: body,
      });

      return axiosResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        const token = LocalStorageService.instance.get(EStorageType.Token)
        if (token) {
          await this.callRefreshToken()
          this.axiosClient.defaults.headers["Authorization"] = `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          headers = {
            Authorization : `Bearer ${LocalStorageService.instance.get(EStorageType.Token)}`
          }
          var axiosResponse = await this.axiosClient.request<T>({
            method: "patch",
            url: `${this.apiUrl}${version}/${url}`,
            headers,
            data: body,
          });
          return axiosResponse.data;
        }
      }
      return Promise.reject(error.response);
    }
  }

  public setupEnvironment(isProduction: boolean) {
    if (isProduction) {
      this.apiUrl = this.prodUrl;
    } else {
      this.apiUrl = this.devUrl;
    }
  }

  private callRefreshToken() {
    const token: string = LocalStorageService.instance.get(EStorageType.Token);
    const refreshToken: string = LocalStorageService.instance.get(
      EStorageType.RefresToken
    );
    return new Promise((resolve, reject) => {
      const url = 'auth/token/refresh';
      const headers: any = {
      };
      const body = { token, refresh_token: refreshToken };

      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          LocalStorageService.instance.set(EStorageType.Token, result.token);
          resolve(result);
        })
        .catch((err) => {
          if (err.status == 400) {
            LocalStorageService.instance.clear();
            this.unauthorizedSubject.next();
          }
          reject();
        });
    });
  }

}
